




















import { Component, Vue } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import ArticleCreatePopup from '@/modules/articles/components/ArticleCreatePopup.vue';
import { ArticleTypeEnum } from '../enums/ArticleTypeEnum';
import { ArticleStatusEnum } from '../enums/ArticleStatusEnum';

import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ArticleCategoryClient, ArticlesClient, IArticle, IArticleCategory } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    Datagrid,
    ArticleCreatePopup,
  },
})
export default class ArticlesOverviewPage extends Vue {
  private selectedWorkType: string = '';
  private articles: IArticle[] = [];
  private articleCategories: IArticleCategory[] = [];

  public async mounted() {
    this.articles = await new ArticlesClient(undefined, this.$axios).getAll();

    await this.getArticleCategories();
  }

  public add() {
    (this.$refs.createPopup as ArticleCreatePopup).show();
  }

  public cellclick(e: any) {
    if (e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/articles/${e.data.id}` });
    }
  }

  public deleteRow(e: any) {
    this.$store.dispatch('articles/delete', e.data);
    e.cancel = true;
  }

  private async getArticleCategories() {
    this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();
  }

  get articleTypesOptions() {
    const items = [
      {value: ArticleTypeEnum.Default, text: 'Standaard'},
      {value: ArticleTypeEnum.Combiniation, text: 'Combinatie'},
    ];

    return { dataSource: items, displayExpr: 'text', valueExpr: 'value' };
  }

  get articleStatusOptions() {
    const items = [
      {value: ArticleStatusEnum.Active, text: 'Actief'},
      {value: ArticleStatusEnum.Disabled, text: 'Inactief'},
    ];

    return { dataSource: items, displayExpr: 'text', valueExpr: 'value', filterExpr: 'text' };
  }

  get items() {
    if (this.selectedWorkType) {
      return this.articles
        .filter((o: IArticle) => o.allowedWorktypes && o.allowedWorktypes.indexOf(this.selectedWorkType) !== -1);
    }

    return this.articles;
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'before',
        widget: 'dxLookup',
        options: {
          dataSource: new DataSource({
            store: new dxCustomStore({
              load: async (loadOptions) => {
                  const result = this.$store.getters['catalogs/list']('WorkTypes');
                  return {
                      data: result.values,
                  };
              },
              byKey: (val: any) => {
                  return val;
              },
            }),
            paginate: true,
          }),
          searchEnabled: true,
          showClearButton: true,
          width: 300,
          onValueChanged: (e: any) => {
            if (e && e.value) {
              self.selectedWorkType = e.value;
              return;
            }
            self.selectedWorkType = '';
          },
          placeholder: 'Filter op soort werk',
        },
      },
    ];
  }

  get loading() {
    return this.$store.getters['articles/loading'];
  }

  get articleCategoryOptions() {
    const items = this.articleCategories.map(ac => ({
      value: ac.id,
      text: ac.name
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value'
    };
  }

  get columns() {
    const projecttypeCatalog = this.$store.getters['catalogs/list']('ProjectTypes') as ICatalogList;
    const projecttypes = projecttypeCatalog ? projecttypeCatalog.values : [];
    const salespriceColumns: any[] = [];

    // create column objects for the different project types
    projecttypes.forEach((type: any) => {
      salespriceColumns.push({
        caption: type,
        dataType: 'number',
        format: CURRENCY_FORMAT,
        alignment: 'left',
        calculateCellValue(value: IArticle) {
          if (!value || !value.variants || value.variants.length < 1 || !value.variants[0].salesPrices) {
            return '';
          }

          const foundValue = value.variants[0].salesPrices.find((price) => price.type === type);
          return foundValue ? foundValue.price : 0;
        },
      });
    });

    return [
      {
        dataField: 'name',
        caption: this.$t('objects.articles.Name'),
      },
      {
        dataField: 'type',
        caption: 'Soort',
        lookup: this.articleTypesOptions,
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: this.articleStatusOptions,
      },
      {
        dataField: 'categoryId',
        caption: 'Categorie',
        lookup: this.articleCategoryOptions,
      },
      {
        dataField: 'description',
        caption: this.$t('objects.articles.Description'),
        allowSearch: false,
      },
      {
        dataField: 'allowedWorktypes',
        caption: 'Toegestaan voor',
        allowSearch: false,
      },
      {
        dataField: 'measuringUnit',
        caption: this.$t('objects.articles.MeasuringUnit'),
        allowSearch: false,
      },
      {
        caption: this.$t('objects.articles.SellingPrices'),
        columns: salespriceColumns,
      },
      {
        type: 'buttons',
        buttons: ['delete'],
      },
    ];
  }
}
